// The small uppercase label above a group of fields, with an optional count on
// the right — "COMPLIANCE   2 of 4 answered".

export interface SectionHeaderProps {
  title: string
  /** Right-aligned status. Reads as done when `complete`, outstanding otherwise. */
  count?: string
  complete?: boolean
}

export const SectionHeader = ({
  title,
  count,
  complete = false,
}: SectionHeaderProps) => (
  <div className="flex items-baseline justify-between gap-2">
    <span className="text-[10px] font-semibold uppercase tracking-[0.05em] text-doubleNickel-gray-500">
      {title}
    </span>
    {count && (
      <span
        className={
          complete
            ? 'text-[10px] font-semibold text-doubleNickel-success-700'
            : 'text-[10px] font-semibold text-doubleNickel-warning-700'
        }
      >
        {count}
      </span>
    )}
  </div>
)
